import { render, staticRenderFns } from "./ContrConfiguracao.vue?vue&type=template&id=d0efa66a&"
import script from "./ContrConfiguracao.vue?vue&type=script&lang=js&"
export * from "./ContrConfiguracao.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/contrConfiguracao.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports